// src/components/filter.
import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import {
    Col,
    Label,
    Row,
} from "reactstrap"
import toastr from "toastr";



//import components
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { saveQuestionAnswer, finalSubmissionQuestionAnswers } from "store/actions";
import CompleteSurveyModel from "../CompleteSurvey/CompleteSurvey";
import { listSurvey } from "store/actions";

const PhaseFive = props => {
    //meta title
    document.title = `${props.t("Survey Phase Five")}  | ${props.t("Participant")}`;
    const { state } = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { surveyData, loading, error, successMsg } = useSelector((state) => state.Survey);



    const [modal, setModal] = useState(false);
    const [selectedCheck, setSelectedCheck] = useState([]);
    const [questions, setQuestions] = useState(surveyData?.survey?.phase_six || []);


    const toggle = () => {
        if (modal) {
            setModal(false);

        } else {
            setModal(true);
        }
    };

    const onNext = () => {

        if (questions.length < 5) {

            if (selectedCheck.length < 1) {
                toastr.error(props.t("Please select checkboxes."));
                return
            }

            const submissions = selectedCheck.map((data) => ({
                id: data?.id,
                questionnaire_id: data?.questionnaire_id,
                page: 1,
                question_type: data?.question_type,
                answer: 1
            }));
            dispatch(finalSubmissionQuestionAnswers({ submissions }, "rater"))

            // selectedCheck?.map(async (data) => {
            //     let objValues = {
            //         "id": data?.id,
            //         "questionnaire_id": data?.questionnaire_id,
            //         "page": 1,
            //         "question_type": data?.question_type,
            //         "answer": 1
            //     };
            //     dispatch(saveQuestionAnswer(objValues, "rater"));

            // });
            toggle();
            return;
        }

        if (selectedCheck.length < 5) {
            toastr.error(props.t("Please select five checkboxes."));
            return
        } else {

            const submissions = selectedCheck.map((data) => ({
                id: data?.id,
                questionnaire_id: data?.questionnaire_id,
                page: 1,
                question_type: data?.question_type,
                answer: 1
            }));
            dispatch(finalSubmissionQuestionAnswers({ submissions }, "rater"));


            // selectedCheck?.map(async (data) => {
            //     let objValues = {
            //         "id": data?.id,
            //         "questionnaire_id": data?.questionnaire_id,
            //         "page": 1,
            //         "question_type": data?.question_type,
            //         "answer": 1
            //     };
            //     dispatch(saveQuestionAnswer(objValues, "rater"));

            // });

            toggle();
            return
        }
    }

    const selectCheck = (obj) => {
        // if (questions.length < 5) {
        //     setSelectedCheck([...selectedCheck, obj]);
        //     return;
        // }

        // if (selectedCheck.includes(obj)) {
        //     const updatedSelectedCheck = selectedCheck.filter((item) => item !== obj);
        //     setSelectedCheck(updatedSelectedCheck);
        // } else if (selectedCheck.length >= 5) {
        //     toastr.error(props.t("Select only five checkboxes."));
        // } else {
        //     setSelectedCheck([...selectedCheck, obj]);
        // }

        if (selectedCheck.some(item => item.id === obj.id)) {
            const updatedSelectedCheck = selectedCheck.filter(item => item.id !== obj.id);
            setSelectedCheck(updatedSelectedCheck);
        } else if (selectedCheck.length < 5) {
            setSelectedCheck([...selectedCheck, obj]);
        } else if (selectedCheck.length >= 5) {
            toastr.error(props.t("Select only five checkboxes."));
        } else {
            setSelectedCheck([...selectedCheck, obj]);
        }
    };

    useEffect(() => {
        fetchSurveyData()
    }, [])

    const fetchSurveyData = () => {
        dispatch(listSurvey("rater"))
    }

    useEffect(() => {

        // if (surveyData?.survey_status == "complete") {
        //     navigate('/save-servey')
        // }

        if (surveyData?.survey?.phase_six) {
            setQuestions(surveyData?.survey?.phase_six || []);
        }

    }, [surveyData]);

    useEffect(() => {
        if (!surveyData || !surveyData.survey_answers || !questions || questions.length === 0) return;

        const selectedIds = surveyData?.survey_answers
            ?.filter(item => item.answer_type === "checkbox")
            .map(item => item.question_id) || [];



        // Filter questions that match selectedIds
        const selectedQuestions = questions.filter(question => selectedIds.includes(question.id));

        if (selectedQuestions.length > 0) {
            setSelectedCheck(selectedQuestions); // Set all selected questions at once
        }
    }, [surveyData, questions]);

    return (
        <React.Fragment>

            <div className="page-content">
                <div className="container-fluid">
                    <CompleteSurveyModel
                        modal={modal}
                        toggle={toggle}
                    />

                    <Row>
                        <div className="self-survey-main">
                            <div className="self-survey-inner phasefive-list-thanks">
                                <div dangerouslySetInnerHTML={{ __html: surveyData?.survey?.phase_five }} />
                                {
                                    questions?.map((data, index) => {
                                        return (
                                            <>
                                                <div className="phasefive-list-data" key={index}>
                                                    <label className="question-radio">
                                                        <input
                                                            id={index}
                                                            type="checkbox"
                                                            // checked={selectedCheck.includes(data)}
                                                            checked={selectedCheck.some((item) => item.id === data.id)}
                                                            onChange={() => selectCheck(data)}
                                                            onClick={() => selectCheck(data)}
                                                        />
                                                        <span className="question-radio-click"></span>
                                                    </label>

                                                    <Label style={{ cursor: "pointer" }} for={index}><div className="counting-title d-flex"> <div className="counting">{index + 1}. </div> <div className="counting-cnt" dangerouslySetInnerHTML={{ __html: data.text }} /></div></Label>
                                                </div>
                                            </>
                                        )
                                    })
                                }
                            </div>
                            <div className="self-survey-inner-btn-div">
                                <button className="previous-ques" onClick={() => navigate('/complete-self-servey/phase-four', {
                                    state: {
                                        surveyData: surveyData,
                                        prev_index: state?.prev_index,
                                        prev_two_page_index: state?.prev_two_page_index
                                    }
                                })}>{props.t('Previous')}</button>
                                <button className="self-survey-btn" onClick={() => onNext()}>{props.t('Next')}</button>
                            </div>
                        </div>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    );
}

PhaseFive.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(PhaseFive);
